/**
 * Methoden (Methodology) content page generator
 */
import { esc } from '@/utils/escape';
import { generateSubpageShell } from './subpage-shell';

export function generateMethodenHTML(settings: any, components: any): string {
  const page = settings.pageMethoden || {};
  const sec = page.sections || {};
  const steps = page.steps || [];
  const tools = page.tools || [];

  const stepsHTML = steps.map(function(step: any, i: number) {
    return '        <div class="method-step">\n' +
      '          <div class="method-step__icon">' + (step.icon || (i + 1)) + '</div>\n' +
      '          <div class="method-step__content">\n' +
      '            <h3>' + esc(step.title) + '</h3>\n' +
      '            <p>' + esc(step.text) + '</p>\n' +
      '          </div>\n' +
      '        </div>';
  }).join('\n');

  const toolsHTML = tools.map(function(tool: any) {
    return '        <div class="tool-card">\n' +
      '          <div class="tool-card__name">' + esc(tool.name) + '</div>\n' +
      '          <div class="tool-card__desc">' + esc(tool.description) + '</div>\n' +
      '        </div>';
  }).join('\n');

  const bodyContent =
    '      <section class="content-page__hero">\n' +
    '        <h1>' + esc(page.heroTitle || 'Unsere Methodik') + '</h1>\n' +
    '        <p>' + esc(page.heroSubtitle || '') + '</p>\n' +
    '      </section>\n\n' +
    (sec.intro !== false && page.introText ? '      <section class="content-section">\n' +
    '        <p class="content-section__text">' + esc(page.introText) + '</p>\n' +
    '      </section>\n\n' : '') +
    (sec.steps !== false ? '      <section class="method-steps">\n' +
    stepsHTML + '\n' +
    '      </section>\n\n' : '') +
    (sec.tools !== false && tools.length ? '      <section class="content-section">\n' +
    '        <h2 class="content-section__title">Unsere Tools</h2>\n' +
    '        <div class="tools-grid">\n' +
    toolsHTML + '\n' +
    '        </div>\n' +
    '      </section>\n\n' : '') +
    (sec.philosophy !== false && page.philosophyTitle ? '      <section class="page-cta">\n' +
    '        <h2>' + esc(page.philosophyTitle) + '</h2>\n' +
    '        <p>' + esc(page.philosophyText || '') + '</p>\n' +
    '      </section>\n' : '');

  return generateSubpageShell(settings, components, {
    title: page.heroTitle || 'Methoden',
    metaDesc: page.heroSubtitle || '',
    bodyContent: bodyContent,
  });
}
